import { useEffect } from 'react'
import Providers from './app/Providers'
import Router from './app/Router'

const REFRESH_AFTER = 6 * 60 * 60 * 1000

function App() {
    useEffect(() => {
        const lastVisit = localStorage.getItem('lastVisit')
        const now = Date.now()

        if (lastVisit && now - Number(lastVisit) > REFRESH_AFTER) {
            localStorage.setItem('lastVisit', String(now))
            window.location.reload()
            return
        }

        localStorage.setItem('lastVisit', String(now))
    }, [])

    return (
        <Providers>
            <Router />
        </Providers>
    )
}

export default App
